// ArcadeOpsLogo — a distinctive SVG monogram mark for Arcade Ops.
//
// This is intentionally NOT a Lucide icon. It's a custom SVG that reads as an
// arcade cabinet silhouette from a distance and an "AO" monogram up close.
// Composed of:
//   - a black cabinet body with a thin neon-yellow border and mitred corners
//   - a cyan CRT-scanline stripe near the top edge
//   - a bold "A" letterform (two mitred bars + crossbar) in neon-yellow
//   - an "O" rendered as a coin-slot ring with a slot bar
//   - a magenta scanline near the bottom edge
//
// Colors are literal hex (not tailwind classes) so the same SVG works in
// PDFs, favicons, social OG images, and email templates without a CSS
// dependency. `size` controls the pixel size; `showWordmark` renders the
// "ARCADE OPS · Business in a Box" lockup next to the mark.

export default function ArcadeOpsLogo({
  size = 40,
  showWordmark = false,
  className = "",
  "data-testid": testId = "arcade-ops-logo",
}) {
  return (
    <div className={`inline-flex items-center gap-3 ${className}`} data-testid={testId}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 48 48"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="Arcade Ops"
        role="img"
        className="shrink-0"
      >
        <defs>
          <linearGradient id="ao-yellow" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" stopColor="#faff00" />
            <stop offset="1" stopColor="#d9c000" />
          </linearGradient>
        </defs>
        {/* cabinet body */}
        <rect x="1.5" y="1.5" width="45" height="45" fill="#050505" stroke="url(#ao-yellow)" strokeWidth="2" />
        {/* CRT scanline (top) */}
        <rect x="6" y="7" width="36" height="1.5" fill="#00e5ff" />
        {/* A — mitred bars */}
        <path
          d="M 11 35 L 19 12 L 27 35"
          fill="none"
          stroke="url(#ao-yellow)"
          strokeWidth="3.4"
          strokeLinejoin="miter"
          strokeMiterlimit="4"
        />
        <line x1="14" y1="27" x2="24" y2="27" stroke="url(#ao-yellow)" strokeWidth="2.6" />
        {/* O — coin-slot ring */}
        <circle cx="35" cy="24" r="5" fill="none" stroke="url(#ao-yellow)" strokeWidth="2.6" />
        <rect x="33" y="23" width="4" height="2" fill="#faff00" />
        {/* magenta scanline (bottom) */}
        <rect x="6" y="40" width="36" height="1.5" fill="#ff2e8a" opacity="0.75" />
      </svg>
      {showWordmark && (
        <div className="leading-none">
          <div className="font-heading font-black text-lg tracking-tight">ARCADE OPS</div>
          <div className="font-mono text-[10px] text-neon-yellow uppercase tracking-[0.28em] mt-1">
            Business in a Box
          </div>
        </div>
      )}
    </div>
  );
}
